import actions from "@/core/store/modules/notification/actions";
import getters from "@/core/store/modules/notification/getters";
import mutations from "@/core/store/modules/notification/mutations";


export default {
    state: {
        notifications: {},
        groups: {},
        payment:{},
        total: 0,
        login_as_client:false
    },
    getters,
    mutations,
    actions
}